import React, { ChangeEvent } from "react";
import { UserDTO } from "../../../DTO/Userx";
import UserForm from "./UserForm";

interface UserDialogProps {
    visible: boolean;
    user: UserDTO | null;
    isNewUser: boolean;
    onHide: () => void;
    onSubmit: () => void;
    onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onRolesChange: (event: { value: string[] }) => void;
    onUserEnabledChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const UserDialog: React.FC<UserDialogProps> = ({
                                                   visible,
                                                   user,
                                                   isNewUser,
                                                   onHide,
                                                   onSubmit,
                                                   onInputChange,
                                                   onRolesChange,
                                                   onUserEnabledChange,
                                               }) => {
    if (!visible) return null;

    return (
        <div className="fixed inset-0 bg-ink/50 flex items-center justify-center z-50">
            <div className="bg-surface border border-border rounded shadow-md w-full max-w-2xl p-6 relative">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-semibold text-primary">
                        {isNewUser ? "Create New User" : "Edit User"}
                    </h2>
                    <button
                        onClick={onHide}
                        className="text-text-secondary hover:text-on-surface text-2xl transition-colors"
                    >
                        ×
                    </button>
                </div>

                {user && (
                    <UserForm
                        user={user}
                        isNewUser={isNewUser}
                        onInputChange={onInputChange}
                        onRolesChange={onRolesChange}
                        onUserEnabledChange={onUserEnabledChange}
                    />
                )}

                <div className="mt-6 flex justify-end space-x-3">
                    <button
                        onClick={onHide}
                        className="px-4 py-2 rounded-md bg-border hover:bg-primary-variant text-on-surface transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onSubmit}
                        className="btn-primary"
                    >
                        {isNewUser ? "Create" : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserDialog;
